import gql from 'graphql-tag';

export const GET_CELL_BASES = gql`
    query (
        $golf_group_code: String
        $golf_code: String
    ){
        getCellBases (
            golf_group_code: $golf_group_code
            golf_code: $golf_code
        ) {
            CellBases {
                id
                course_name
                course_code
                play_date_start
                play_date_valid
                play_time_start
                play_time_valid
                interval
                updated_at
                display_date
            }
        }
    }
`;

export const GET_CELL_BASE = gql`
    query (
        $id: ID!
    ){
        getCellBaseDetail(
            id: $id
        ){
            golf_code
            golf_name
            course_name
            course_code
            play_date_start
            play_date_valid
            play_time_start
            play_time_valid
            interval
        }
    }
`;

export const CREATE_CELL_BASES = gql`
    mutation(
        $golf_group_code:  String!
        $golf_code:        String!
        $course_code:      String!
        $play_date_start:  String!
        $play_date_valid:  String!
        $play_time_start:  String!
        $play_time_valid:  String!
        $interval:         String!
    ){
        createCellBases(
            golf_group_code:    $golf_group_code
            golf_code:    $golf_code
            course_code:    $course_code
            play_date_start:    $play_date_start
            play_date_valid:    $play_date_valid
            play_time_start:    $play_time_start
            play_time_valid:    $play_time_valid
            interval:    $interval
        ) {
            result
        }
    }
`;

export const UPDATE_CELL_BASES = gql`
    mutation(
        $golf_group_code:  String!
        $golf_code:        String!
        $course_code:      String!
        $play_date_start:  String!
        $play_date_valid:  String!
        $play_time_start:  String!
        $play_time_valid:  String!
        $interval:         String!
        $id: ID!
    ){
        updateCellBases(
            golf_group_code:    $golf_group_code
            golf_code:    $golf_code
            course_code:    $course_code
            play_date_start:    $play_date_start
            play_date_valid:    $play_date_valid
            play_time_start:    $play_time_start
            play_time_valid:    $play_time_valid
            interval:    $interval
            id: $id
        ) {
            result
        }
    }
`;

export const DELETE_CELL_BASES = gql`
    mutation (
        $id: ID!
    ){
        deleteCellBases(
            id: $id
        ) {
            result
        }
    }
`;

// 基本情報に紐づく枠の、枠ステータスの日時一覧を取得する
export const GET_CELL_BASE_RESERVE_STATUS = gql`
    query (
        $id: Int!
        $year: String!
        $month: String!
    ){
        getCellBaseReserveStatus(
            id: $id
            year: $year
            month: $month
        ){
            play_start
            course_code
            days{
                day1{
                    status
                    flg
                }
                day2{
                    status
                    flg
                }
                day3{
                    status
                    flg
                }
                day4{
                    status
                    flg
                }
                day5{
                    status
                    flg
                }
                day6{
                    status
                    flg
                }
                day7{
                    status
                    flg
                }
                day8{
                    status
                    flg
                }
                day9{
                    status
                    flg
                }
                day10{
                    status
                    flg
                }
                day11{
                    status
                    flg
                }
                day12{
                    status
                    flg
                }
                day13{
                    status
                    flg
                }
                day14{
                    status
                    flg
                }
                day15{
                    status
                    flg
                }
                day16{
                    status
                    flg
                }
                day17{
                    status
                    flg
                }
                day18{
                    status
                    flg
                }
                day19{
                    status
                    flg
                }
                day20{
                    status
                    flg
                }
                day21{
                    status
                    flg
                }
                day22{
                    status
                    flg
                }
                day23{
                    status
                    flg
                }
                day24{
                    status
                    flg
                }
                day25{
                    status
                    flg
                }
                day26{
                    status
                    flg
                }
                day27{
                    status
                    flg
                }
                day28{
                    status
                    flg
                }
                day29{
                    status
                    flg
                }
                day30{
                    status
                    flg
                }
                day31{
                    status
                    flg
                }
            }
        }
    }
`;

// 枠ステータスの更新
export const UPDATE_RESERVE_STATUS_TO_CELL_LINKS = gql`
    mutation($releaseCellBaseInput: [releaseCellBaseInput]){
    updateReserveStatusToCellLinks(
        releaseCellBaseInput: $releaseCellBaseInput
    ){
        result
    }
}
`;
